"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeSessionStore = exports.safeLocalStore = exports.isEmpty = exports.getSession = exports.getPersistent = void 0;
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/**
 * helpers.js
 *
 * Holds generic helper functions for analytics use.
 */

/**
 * Reusable Regex functions.
 */
var rxSurroundQuotes = /^["'](.+(?=["']$))["']$/;

/**
 * Will take in any input and return true/false if it is "empty".
 * Avoids needing a library import for such a simple function (eg lodash)
 * @param {*} value
 * @returns boolean
 */
var isEmpty = function isEmpty(value) {
  return value === undefined || value === null || (0, _typeof2.default)(value) === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};

/**
 * Checks accessibility of localStorage / sessionStorage
 * Useful in incognito/private modes for localized domains eg: .com.hk
 */
exports.isEmpty = isEmpty;
var isStorageAccessible = function isStorageAccessible(getStorage) {
  try {
    var key = '__is_storage_accessible_test_key';
    var storage = getStorage();
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

/* Reusuable constants for evaluating session & local storage. */
var safeSessionStore = isStorageAccessible(function () {
  return sessionStorage;
});
exports.safeSessionStore = safeSessionStore;
var safeLocalStore = isStorageAccessible(function () {
  return localStorage;
});

/**
 * A helper to get a consistent value in a key when a value is missing (and
 * doesn't have a default value).
 * @returns string
 */
exports.safeLocalStore = safeLocalStore;
var getDefaultMissingValue = function getDefaultMissingValue() {
  return undefined;
};

/**
 * A helper to clean up a string value per the requirements of some values for ADP.
 * @param {string} val
 * @returns string
 */
var cleanseValue = function cleanseValue(val) {
  return (
    /* Recreate the current value formats by running rules to filter
         the value here.
         1. Strip begin and end quotes (' or ")
      */
    (val === null || val === void 0 ? void 0 : val.replace(rxSurroundQuotes, '$1')) || val
  );
};

/**
 * Note: currently unused. If we don't use it for Search, remove it (TODO).
 *
 * A helper to get the value by key from the browser's localStorage.
 * Also performs clean up, or missed value handling.
 * @param {string} key
 * @returns
 */
var getPersistent = function getPersistent(key) {
  if (safeLocalStore) {
    if (localStorage.getItem(key) !== null) {
      return cleanseValue(localStorage.getItem(key));
    }
  }
  return getDefaultMissingValue();
};

/**
 * A helper to get the value by key from the browser's sessionStorage.
 * Also performs clean up, or missed value handling.
 * @param {string} key
 * @returns
 */
exports.getPersistent = getPersistent;
var getSession = function getSession(key) {
  if (safeSessionStore) {
    if (sessionStorage.getItem(key) !== null) {
      return cleanseValue(sessionStorage.getItem(key));
    }
  }
  return getDefaultMissingValue();
};
exports.getSession = getSession;